









































import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { AccountModule } from '../store/account-module'
import { RouterToken } from '@/config/injection-tokens'
import { VueRouter } from 'vue-router/types/router'
import { isNotBlank } from '@/shared/utils/is-blank'
import HttpError from '@/shared/components/http-error.vue'
import DefaultHeader from '@/main/default-header.vue'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { CONFIRM_ACCOUNT } from '@/business/account/store/types'
import { loggerFor } from '@/shared/utils/logger'
import UnifyPage from '@/shared/components/unify/unify-page.vue'
import { Account } from '@/api/generated'

@Component({
  name: 'confirm-account',
  components: { UnifyPage, DefaultHeader, HttpError },
})
export default class ConfirmAccount extends Vue {
  /**
   * The error that occurred when trying to confirm the account
   */
  public error: Response | null = null

  /**
   * Error specific description
   */
  public errorDescription:
    | null
    | 'not_found'
    | 'forbidden'
    | 'no_token'
    | 'account_forbidden' = null

  /**
   * The organisation id of the confirmed account
   */
  public organisationId?: number

  /**
   * Indicates that the confirmation and the authentication were successful
   */
  public success = false

  private accountModule = Injector.get(AccountModule)
  private loaderHelper = Injector.get(LoaderHelper)
  private router = Injector.get<VueRouter>(RouterToken)

  private logger = loggerFor('ConfirmAccount')

  get loading() {
    return this.loaderHelper.isLoading(CONFIRM_ACCOUNT)
  }

  public mounted() {
    const token = this.router.currentRoute.query.token as string | undefined

    if (isNotBlank(token)) {
      this.confirmAccount(token)
    } else {
      this.errorDescription = 'no_token'
    }
  }

  public async confirmAccount(token: string) {
    this.accountModule
      .confirmAccount({ token })
      .then((account: Account) => {
        this.organisationId = account.organisation.id
        this.success = true
      })
      .catch(cause => {
        this.logger.error(cause)

        this.error = cause.error

        const status = cause.error.status
        const type = cause.type

        if (type === 'confirmation') {
          if (status === 403) {
            this.errorDescription = 'forbidden'
          } else if (status === 404) {
            this.errorDescription = 'not_found'
          }
        } else {
          if (status === 403) {
            this.errorDescription = 'account_forbidden'
          }
        }
      })
  }
}
